import React, { useCallback } from 'react';
import { getOperation } from "../../../../../../contexts/OperationContext";
import { getPlan } from "../../../../../../contexts/PlanOperationContext/Plan";
import { ACTION_TYPE, OP_STATUS, OPERATION_TYPE } from "../../../../../../util/varibles/constants";
import { addClassName, removeClassName } from "../../../../../../util/varibles/global";
import HarvestView from "../../../../_components/ContentOperation/HarvestView";
import { IPropsOp } from "./";
import WrapperOperation from "./_components/WrapperOperation";
import styles from './style.module.scss';

interface IProps extends IPropsOp {
    operationType: OPERATION_TYPE
    isOwn: boolean
    isVesselOwn: boolean
    permission: any
    status: OP_STATUS
}

const Harvest: React.FC<IProps> = (props) => {
    const { isOwn, data } = props;
    const { operation, vessel, activity_log } = data;
    const get = getOperation();
    const getBoxOfOp = getPlan()

    const edit = useCallback(() => {
        return {
            isShow: true,
            operationType: OPERATION_TYPE.HARVEST,
            editMode: ACTION_TYPE.EDIT,
            values: {
                operation,
                activity_log,
                vessel
            }
        }
    }, [operation, vessel, activity_log]);

    const handleMouseOver = () => {
        const { calendarRef } = getBoxOfOp();
        if (calendarRef) {
            const { modeDrag } = calendarRef()?.dataset || {};
            if (modeDrag !== `${OPERATION_TYPE.HARVEST}` || !isOwn)
                return;

            const { rootRef } = get();
            if (rootRef) {
                const el = rootRef();
                const { modeDrag = '' } = el.dataset || {};
                if (modeDrag.length === 0)
                    addClassName(el, styles['merge-hover']);
            }
        }
    }

    const handleMouseLeave = () => {
        const { calendarRef } = getBoxOfOp();
        if (calendarRef) {
            const { modeDrag } = calendarRef()?.dataset || {};
            if (modeDrag !== `${OPERATION_TYPE.HARVEST}` || !isOwn)
                return;

            const { rootRef } = get();
            if (rootRef)
                removeClassName(rootRef(), styles['merge-hover']);
        }
    }

    return <WrapperOperation
        {...props}
        edit={edit}
        event={{
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave
        }}
    >
        <div className={[styles['content-wrapper'], styles.layout].join(' ')}>
            <HarvestView
                status={props.status}
                data={data}
                isOwn={isOwn}
            />
        </div>
    </WrapperOperation>;
};

export default Harvest;
